import http from '@/services/http'
import { settingsUrl } from '@/services/url'
import type * as Types from './type'
import { settingFormat } from './utils'

/**
 * 获取商家设置
 * @param data
 * @returns
 * @deprecated
 */
export const getSetting = async <T = any>(data: Types.ISettingParams) =>
  await http.admin.post<Types.ISetting<T>>(settingsUrl.getSetting, data).then((res) => {
    return {
      ...res,
      data: settingFormat<T, string>(res.data),
    }
  })

// 批量获取商家设置
export const getSettingList = async <T = any>(settingCodes: Types.SettingCode[]) =>
  await http.admin
    .post<{
      list?: Types.ISetting[]
    }>(settingsUrl.getSettingList, {
      settingCodes,
    })
    .then((res) => {
      return {
        ...res,
        data: {
          ...res.data,
          list: res.data.list?.map((item) => settingFormat<T, any>(item)),
        },
      }
    })

// 更新商家设置
// eslint-disable-next-line @typescript-eslint/ban-types
export const updateSetting = async <T extends object>({ dataValue, settingCode }: Types.ISetting<T>) => {
  return http.admin.post(settingsUrl.updateSetting, {
    dataValue: JSON.stringify(dataValue),
    settingCode,
  })
}

export const updateOtherSettings = (data) => http.admin.post('/api/settings/batchUpdateSellerSetting', data)
// 获取用户设置
export const getUserSetting = async <T = any>(data: Types.ISettingParams) =>
  await http.admin.post<Types.ISetting<T>>('/api/settings/getUserSetting', data).then((res) => {
    return {
      ...res,
      data: settingFormat<T, string>(res.data),
    }
  })
// 批量获取用户设置
export const getUserSettingList = async <T = any>(settingCodes: Types.SettingCode[]) =>
  await http.admin
    .post<{
      list?: Types.ISetting[]
    }>('/api/settings/listUserSetting', {
      settingCodes,
    })
    .then((res) => {
      return {
        ...res,
        data: {
          ...res.data,
          list: res.data.list?.map((item) => settingFormat<T, any>(item)),
        },
      }
    })

// 更新用户设置
// eslint-disable-next-line @typescript-eslint/ban-types
export const updateUserSetting = async <T extends object>({ dataValue, settingCode }: Types.ISetting<T>) => {
  return http.admin.post('/api/settings/updateUserSetting', {
    dataValue: JSON.stringify(dataValue),
    settingCode,
  })
}

export const syncFrequencyModeUpdate = (data: Types.SyncFrequencyModeUpdateReq) => {
  return http.admin.post('/api/stock/sync/setting/syncFrequencyModeUpdate', data, { toast: true })
}

// 获取商家设置
export const batchGetSellerSetting = (data: Types.SellerSettingListReqDTO) => {
  return http.admin.post<Types.BatchGetRes>('/api/settings/batchGet', data)
}

interface InboundMarkPreviewReqDTO {
  /**语言 */
  language?: string
  numOfPerPage: number
}

interface PreviewRes {
  url?: string
}

/**
 * **接口** [唛头预览↗](https://apidoc.inshopline.com/#/project/Java/80/feature%2F3823_inbound_mark/interface/951542109736e19bb49ddb77b7aebd26)
 * @请求头 `POST /api/inbounds/mark/preview`
 * @更新时间 `2024-10-21 20:20:12`
 */
export function postPreview(data?: InboundMarkPreviewReqDTO) {
  return http.admin.post<PreviewRes>(`/api/inbounds/mark/preview`, data)
}
